export default __webpack_public_path__ + "static/media/letpension-logo-small.1c09f94f.svg";